import { createReactComponent } from '@tabler/icons-react';

export const IconCustomFileRestore = createReactComponent(
  'outline',
  'customFileRestore',
  'CustomFileRestore',
  [
    [
      'path',
      {
        key: 'customFileRestore-path',
        d: 'M12.7,16.6c.3-.7.8-1.4,1.5-1.8.7-.4,1.5-.6,2.3-.5.8.1,1.5.5,2.1,1,.3.3.5.6.7.9M12.5,14.8v1.8h1.8M19.5,19.3c-.3.7-.8,1.4-1.5,1.8-.7.4-1.5.6-2.3.5-.8-.1-1.5-.5-2.1-1-.2-.2-.4-.5-.6-.7M19.7,21.1v-1.8h-1.8M13.3,2.4v4c0,.3.1.5.3.7.2.2.4.3.7.3h4M13.3,2.4h-7c-.5,0-1,.2-1.4.6-.4.4-.6.9-.6,1.4v14c0,.5.2,1,.6,1.4.4.4.9.6,1.4.6h3.7M13.3,2.4l5,5M18.3,7.4v4.4',
      },
    ],
  ]
);
